import { colors, fontStyle } from "Constants";

export const styles = {
  headerStyles: {
    padding: "24px 24px 0px 32px",
    fontSize: "2rem",
    color: colors.textDefault,
  },
  modalBodyStyle: {
    fontSize: "1.6rem",
    marginTop: "16px",
    color: colors.textDefault,
    lineHeight: "2.4rem",
    padding: "16px 32px",
    ...fontStyle.medium,
  },
  footerContainerStyle: {
    padding: "24px 32px",
  },
};
